<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import ActionBar from '@/components/common/ActionBar.vue'
import TableActionMenu from '@/components/common/TableActionMenu.vue'
import CreateSuTableDialog from '@/components/suTable/CreateSuTableDialog..vue'
import SuTableExpansionPanel from '@/components/suTable/SuTableExpansionPanel.vue'
import { actionMenuMixin } from '@/mixins/actionMenuMixin'
import { dirtyFieldMixin } from '@/mixins/dirtyFieldMixin'

const { x, y, showMenu, selectedItem, show } = actionMenuMixin()
const { dirtyItems, addDirty, getDirtyClass } = dirtyFieldMixin()

const opened = ref([])
const writeLoading = ref(false)

const store = useStore()
const suTableItems = computed(() => store.state.suTable.items)

const setParameter = (payload) => store.dispatch('suTable/setParameter', payload)
const emptyDirtyItems = () => store.dispatch('suTable/emptyDirtyItems')
const update = () => store.dispatch('suTable/update')
const removeItems = (payload) => store.dispatch('suTable/removeItems', payload)
const deleteObj = (id) => store.dispatch('suTable/deleteItem', id)
const toggleDialog = () => store.dispatch('suTable/toggleDialog')

function togglePanel(id) {
  const index = opened.value.findIndex((panelId) => panelId === id)
  if (index === -1) {
    opened.value.push(id)
  } else {
    opened.value.splice(index, 1)
  }
}

async function saveChanges() {
  writeLoading.value = true
  try {
    await update()
    emptyDirtyItems()
    dirtyItems.value = []
  } catch {
    writeLoading.value = false
  }
  writeLoading.value = false
}

async function deleteSuTable(selectedItem) {
  await deleteObj(selectedItem.id)
  removeItems({
    parameter: 'su_table',
    id: selectedItem.id
  })
}
</script>

<template>
  <ActionBar
    class="pr-3 align-center"
    show-add
    show-save
    @add="toggleDialog()"
    @save="saveChanges()"
  >
    <template v-slot:left>
      <v-card-title> Su table </v-card-title>
      <v-card-subtitle> Please configure the Su tables </v-card-subtitle>
    </template>
  </ActionBar>
  <v-divider class="mt-3" />
  <div v-if="suTableItems.length === 0" class="mt-2 pl-4">
    <small> No Su tables found. Please add a new one. </small>
  </div>
  <v-expansion-panels flat v-model="opened" multiple variant="accordion">
    <v-expansion-panel
      v-for="(suTable, index) in suTableItems"
      :key="suTable"
      :value="suTable.id"
      readonly
    >
      <v-divider v-if="index !== 0"></v-divider>
      <SuTableExpansionPanel
        @toggle="togglePanel(suTable.id)"
        :opened="opened"
        :su-table="suTable"
        :dirtyClass="getDirtyClass(suTable, 'name')"
        @set="setParameter"
        @update="addDirty(suTable, 'name')"
        @right-click="show($event, suTable)"
      />
    </v-expansion-panel>
  </v-expansion-panels>
  <TableActionMenu
    @update:show-menu="showMenu = $event"
    :selected-item="selectedItem"
    :show-menu="showMenu"
    :x="x"
    :y="y"
    :add-button="false"
    @action="deleteSuTable(selectedItem)"
  />
  <CreateSuTableDialog />
</template>
